import { render } from "./Main.vue?vue&type=template&id=fe813014"
const script = {}

import "./Main.vue?vue&type=style&index=0&id=fe813014&lang=scss"

import exportComponent from "E:\\Work\\Elkashef\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__